import {NgModule} from '@angular/core';
import {MaterialModule} from '../material/material.module';
import {BreadcrumbModule} from 'angular-crumbs';
import {MainMenuComponent} from './components/main-menu/main-menu.component';
import {HeaderComponent} from './components/header/header.component';
import {HomeComponent} from './components/home/home.component';
import {ProtectedLayoutComponent} from './components/protected-layout/protected-layout.component';
import {CanActivateHomeService} from './services/guards/can-activate-home.service';
import {CanActivateLoginService} from './services/guards/can-activate-login.service';
import {PublicLayoutComponent} from './components/public-layout/public-layout.component';
import {PermissionErrorComponent} from './components/permission-error/permission-error.component';
import {CommonModule} from '@angular/common';
import {RouterModule} from '@angular/router';
import {UtilitiesModule} from '../utilities/utilities.module';
import {UserModule} from '../user/user.module';
import {BreadcrumbComponent} from './components/breadcrumb/breadcrumb.component';
import { BackButtonComponent } from './components/back-button/back-button.component';
import {CerfMenuComponent} from './components/cerf-menu/cerf-menu.component';

@NgModule({
  declarations: [
    MainMenuComponent,
    HomeComponent,
    HeaderComponent,
    ProtectedLayoutComponent,
    PublicLayoutComponent,
    PermissionErrorComponent,
    BreadcrumbComponent,
    BackButtonComponent,
    CerfMenuComponent
  ],
  imports: [
    CommonModule,
    MaterialModule,
    BreadcrumbModule,
    RouterModule,
    UtilitiesModule,
    UserModule
  ],
  exports: [
    MainMenuComponent,
    HomeComponent,
    HeaderComponent,
    ProtectedLayoutComponent,
    PublicLayoutComponent,
    PermissionErrorComponent,
    BreadcrumbComponent,
    BackButtonComponent,
    CerfMenuComponent
  ],
  providers: [
    CanActivateHomeService,
    CanActivateLoginService
  ]
})
export class LayoutModule { }



// WEBPACK FOOTER //
// /var/www/dnata-cerf-front-end/releases/20200326161233/src/app/modules/layout/layout.module.ts